import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import AppDetailsMixin from '@/helpers/vue_mixins/v2/ecommerce/AppDetailsMixin';
import BaseSideNav from '@/components/v2/BaseSideNav.vue';
import { OVERVIEW_ROUTE, CAMPAIGN_ROUTE, BROADCAST_ROUTE, CUSTOMER_SEGMENT_ROUTE, ACTIVITY_ROUTE, WINNERS_ROUTE, RAFFLE_DRAW_ROUTE, REFERRALS_ROUTE, } from '@/helpers/constants/SurveyRoutes';
let SurveyAndRaffleBundle = class SurveyAndRaffleBundle extends mixins(AppDetailsMixin) {
    get currentRoute() {
        return this.$router.currentRoute;
    }
    get menuItems() {
        const params = {
            appUUID: this.appUuid,
        };
        return [
            {
                icon_path: require('./assets/overview-orange.svg'),
                text: OVERVIEW_ROUTE.title,
                path: {
                    name: OVERVIEW_ROUTE.name,
                    params,
                },
                exact: false,
            },
            {
                icon_path: require('./assets/campaign.svg'),
                text: CAMPAIGN_ROUTE.title,
                path: {
                    name: CAMPAIGN_ROUTE.name,
                    params,
                },
                exact: true,
            },
            {
                icon_path: require('./assets/campaign.svg'),
                text: RAFFLE_DRAW_ROUTE.title,
                path: {
                    name: RAFFLE_DRAW_ROUTE.name,
                    params,
                },
                exact: true,
            },
            {
                icon_path: require('./assets/broadcast.svg'),
                text: BROADCAST_ROUTE.title,
                path: {
                    name: BROADCAST_ROUTE.name,
                    params,
                },
                exact: true,
            },
            {
                icon_path: require('./assets/customer-segment.svg'),
                text: CUSTOMER_SEGMENT_ROUTE.title,
                path: {
                    name: CUSTOMER_SEGMENT_ROUTE.name,
                    params,
                },
                exact: true,
            },
            {
                icon_path: require('./assets/activity.svg'),
                text: ACTIVITY_ROUTE.title,
                path: {
                    name: ACTIVITY_ROUTE.name,
                    params,
                },
                exact: true,
            },
            {
                icon_path: require('./assets/winner.svg'),
                text: WINNERS_ROUTE.title,
                path: {
                    name: WINNERS_ROUTE.name,
                    params,
                },
                exact: true,
            },
            {
                icon_path: require('./assets/referral.svg'),
                text: REFERRALS_ROUTE.title,
                path: {
                    name: REFERRALS_ROUTE.name,
                    params,
                },
                exact: true,
            },
            {
                icon_path: require('./assets/notification.svg'),
                text: 'Notification Manager',
                path: {
                    name: 'survey-notifications',
                    params,
                },
                exact: false,
            },
        ];
    }
};
SurveyAndRaffleBundle = __decorate([
    Component({
        components: {
            BaseSideNav,
        },
    })
], SurveyAndRaffleBundle);
export default SurveyAndRaffleBundle;
